import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonModal from '../../CommonModal/CommonModal';
import { toast } from 'react-toastify';

const DeleteCommentDialog = ({
  open,
  onClose,
  commentId,
  onDeleteComment,
  requestId,
  isAdditionalDocument = false,
}) => {
  const { t } = useTranslation();

  const handleDelete = async () => {
    try {
      await onDeleteComment({
        id: commentId,
        requestId,
        isAdditionalDocument,
      });
      toast.success(t('comment_deleted'), { position: 'top-center' });
      onClose();
    } catch (error) {
      console.error('Error deleting comment:', error);
      toast.error(t('something_went_wrong'), { position: 'top-center' });
    }
  };

  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title={t('delete_comment')}
      message={t('confirm_delete_comment')}
      size="small"
      buttonProps={[
        {
          label: t('cancel'),
          onClick: onClose,
        },
        {
          label: t('delete'),
          onClick: handleDelete,
        },
      ]}
    />
  );
};

export default DeleteCommentDialog;
